import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useFormik } from "formik";
import * as Yup from "yup";
import { styled } from "@mui/material/styles";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

import CallMadeIcon from "@mui/icons-material/CallMade";
import ClearIcon from "@mui/icons-material/Clear";

import Modal from "../../components/Modal";
import { setError, setSuccess } from "../../reducers/appSlice";
import AutocompleteGrupos from "../../commons/AutocompleteGrupos";

const Row = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

const validationSchema = Yup.object().shape({
  grupo: Yup.number().required("Requerido"),
});

const TransferirOrganismoModal = ({
  open,
  handleClose,
  organismo,
  transferir,
}) => {
  const dispatch = useDispatch();
  const [saving, setSaving] = useState(false);

  // const handleSelectOrganismo = (organismo) => setOrganismo(organismo);
  const handleChangeAutocomplete = (value) => {
    formik.setFieldValue("grupo", value);
  };

  const formik = useFormik({
    initialValues: {
      grupo: "",
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      try {
        setSaving(true);
        console.log(organismo)
        await transferir({ ...values, id: organismo.organismoId });
        dispatch(setSuccess("Organismo transferido"));
        handleClose();
      } catch (error) {
        console.log(error);
        dispatch(setError(error.message));
      } finally {
        setSaving(false);
      }
    },
    onReset: () => {},
  });

  // useEffect(() => {
  //   if (!organismo) return;
  //   formik.setFieldValue("organismo", organismo?.id);
  // }, [organismo]);

  useEffect(() => {
    if (!open) {
      setSaving(false);
      // setOrganismo(null);
      formik.handleReset();
    }
  }, [open]);

  return (
    <Modal open={open} handleClose={handleClose} size="md">
      <form
        id="formCambiarGrupo"
        name="formCambiarGrupo"
        onSubmit={formik.handleSubmit}
        onReset={formik.handleReset}
        noValidate
        autoComplete="off"
      >
        <Box mb={2}>
          <Typography variant="titulo">
            Organismo: {organismo?.descripcion}
          </Typography>
        </Box>
        {/* <input type="hidden" id="id" name="id" value={formik.values.id} /> */}
        <Row container spacing={1}>
          <Grid item lg={12} xs={12}>
            <AutocompleteGrupos
              name="grupo"
              error={formik.touched.grupo && Boolean(formik.errors.grupo)}
              helperText={formik.touched.grupo && formik.errors.grupo}
              onChange={handleChangeAutocomplete}
              value={formik.values.grupo}
              fullWidth
            />
          </Grid>
        </Row>

        <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
          <Button
            sx={{ m: 1 }}
            variant="verde"
            color="primary"
            endIcon={<CallMadeIcon />}
            type="submit"
            disabled={saving}
          >
            {saving ? "Transfiriendo..." : "Transferir"}
          </Button>
          <Button
            variant="plata"
            type="button"
            endIcon={<ClearIcon />}
            sx={{ m: 1 }}
            onClick={handleClose}
          >
            Cancelar
          </Button>
        </Box>
      </form>
    </Modal>
  );
};

export default TransferirOrganismoModal;
